import Cookies from 'js-cookie';
import ReadMore from '../readMore/ReadMore';
import classes from './BookDetail.module.css';
import { LanguageContext } from '../../../../context/LanguageContext';
import Button from '../../../../components/buttons/authButton/Button';
import { constantData } from '../../../../utils/helpers/constantData';
import { useNavigate } from 'react-router-dom';
import { PLAN_TYPES } from '../../../../utils/helpers/subscriptions/plans';

const BookDetail = (props) => {
  const { data, purchasesData, productsHandler, read, id, isLocked, setIsAuthorized } = props;
  const navigate = useNavigate();

  const token = Cookies.get('auth_token');
  const productAction =
    purchasesData?.includes(id) && token
      ? constantData.productType[data.productType]
      : ['download'];

  return (
    <LanguageContext.Consumer>
      {(ctx) => {
        return (
          <div className={`${classes.gap20} flex-wrap d-flex`}>
            <div className={`${classes.borderBottom} w-100`}></div>
              <div className={classes.padding}>
                <ReadMore
                  data={data?.description}
                  description={classes.description}
                  read_more_container={classes.read_more_container}
                  isLocked={isLocked}
                />
              </div>
            {!isLocked && (
              <div
                className={`${classes.singleProductPageContainer} ${classes.padding} ${classes.flexWrap} d-flex justify-content-center w-100 align-items-start text-decoration-none`}
              >
                {productAction.map((item) => {
                  return (
                    <Button
                      key={item}
                      textStyle='w-100'
                      divStyle={`${classes.button_container} d-flex w-100 align-items-center justify-content-center justify-content-center`}
                      buttonStyle={`${classes.actions_for_book} border-0 text-center align-items-center d-flex`}
                      onClick={() => productsHandler(item)}
                      image={
                        item !== 'download' &&
                        `../assets/singleProduct/booksData/${item}.svg`
                      }
                      text={
                        ctx.data &&
                        ctx.data[read && item === 'read' ? 'continue' : item][
                          ctx.language
                        ]
                      }
                    />
                  );
                })}
              </div>
            )}
            {isLocked && (
              <div className={classes.premiumCardContainer}>
                <div className={classes.premiumCardNotice}>
                  <span className={classes.premiumCardNoticeText}>
                    {ctx.data?.book_not_included_in_basic_plan[ctx.language]}
                  </span>
                  <span className={classes.premiumCardUpgrade} onClick={() => token ? navigate('/subscription-plans') : setIsAuthorized(true)}>
                    {ctx.data?.upgrade[ctx.language]}
                  </span>
                </div>

                <div className={classes.premiumCardUnlock}>
                  <img src="/assets/singleProduct/locked.svg" alt="" />
                  <span className={classes.premiumCardUnlockText}>
                    {data?.requiredPlan === PLAN_TYPES.PREMIUM ? ctx.data?.unlock_with_premium[ctx.language] : 
                     data?.requiredPlan === PLAN_TYPES.FAMILY ? ctx.data?.unlock_with_vinni_plus_family[ctx.language] : ""}
                  </span>
                </div>
              </div>
            )}
          </div>
        );
      }}
    </LanguageContext.Consumer>
  );
};

export default BookDetail;
